export default "__VITE_ASSET__bEPa9nFC__"